<template>
  <div>
    <div class="mb5">
      <span class="checkbox mr30">
        <input type="checkbox" id="check_all" @change="checkAll">
        <label for="check_all">{{locale.all}}</label>
      </span>
      <span v-if="checked.length > 0" class="mr5">
        {{locale.select}} {{checked.length}} / {{list.length}}
      </span>
      <button type="button" class="btn sizeXs" :disabled="disabledDelete" @click="delItems">{{locale.delete}}</button>
    </div>
    <div class="masorny">
      <button type="button" class="btnAdd card" @click="newItem">+</button>
      <div
        v-for="item of list"
        :key="item.id"
        class="card"
        @click="setEdit(item.id, true)">
        <div class="content">
          <span class="name">{{item.name}}</span>
          <div class="text mt10" v-html="`#${item.tag[lang.default]}`"></div>
        </div>
        <div class="checkbox chkItem">
          <input type="checkbox" :id="`check_${item.id}`" :value="item.id" v-model="checked" @click.stop />
          <label :for="`check_${item.id}`" @click.stop><span class="blind">{{locale.state_public}}</span></label>
        </div>
      </div>
      <Edit
        v-if="activeItem"
        :locale="locale"
        :lang="lang"
        :item="activeItem"
        :cardList="cardList"
        @apply="apply"
        @cancel="setEdit(activeItem, false)" />
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import Edit from '@/components/Talk/TagEdit'

export default {
  name: 'Tag',
  props: [
    'locale',
    'lang',
    'tag',
    'cardList'
  ],
  components: {
    Edit
  },
  computed: {
    list () {
      return this.tag.list
    },
    disabledDelete () {
      return this.checked.length === 0
    }
  },
  data () {
    return {
      activeItem: null,
      tagItem: {
        id: '',
        name: 'New Tag',
        answerType: 'input', // input, card
        tag: {},
        answer: {}, // answerType === 'input'
        answerCard: '' // answerType === 'card'
      },
      checked: []
    }
  },
  methods: {
    newItem () {
      const item = this._.cloneDeep(this.tagItem)
      item.id = UNIQUE.mid()
      item.tag = this.$store.getters['setting/getLangValues']()
      item.answer = this.$store.getters['setting/getLangValues']()
      this.$emit('add', {
        target: 'tag',
        data: item
      })
    },
    checkAll (e) {
      const isChecked = e.target.checked
      this.checked = isChecked ? this.list.map(x => x.id) : []
    },
    setEdit (id, isActive) {
      this.activeItem = isActive ? this.list.find(x => x.id === id) : null
    },
    delItems () {
      const data = {
        target: 'tag',
        ids: this.checked
      }
      if (window.confirm(this.locale.confirm_delete_talk_tag)) {
        this.$emit('del', data)
        this.checked = []
      }
    },
    apply (data) {
      this.$emit('apply', data)
    }
  }
}
</script>
